var _style, _polygon, _path, _line, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHydrophobicFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.hydrophobicFilter-st0{fill:#FFFFFF;stroke:currentColor;stroke-miterlimit:10;}\r\n\t.hydrophobicFilter-st1{stroke:currentColor;stroke-miterlimit:10;}\r\n\t.hydrophobicFilter-st2{fill:none;stroke:currentColor;stroke-miterlimit:10;}\r\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "hydrophobicFilter-st0",
    points: "68.7,45.4 68.7,34.5 51.3,34.5 51.3,45.4 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "hydrophobicFilter-st0",
    d: "M51.6,24.7L45.3,5.5C45,4.6,44.2,4,43.2,4h-6.5c-0.9,0-1.7,0.6-2.1,1.5l-6.3,19.2c-0.1,0.3-0.1,0.4-0.1,0.7 v10.3L7.9,37.3v5.3l20.3,1.7v10.3c0,0.3,0.1,0.4,0.1,0.7l6.3,19.2c0.3,0.9,1.1,1.5,2.1,1.5h6.5c0.9,0,1.8-0.6,2.1-1.5l6.3-19.2 c0.1-0.3,0.1-0.5,0.1-0.8V25.4C51.7,25.1,51.6,25,51.6,24.7z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "hydrophobicFilter-st1",
    x1: 40.1,
    y1: 4.1,
    x2: 40.1,
    y2: 76
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "hydrophobicFilter-st2",
    d: "M39.7,41.5c-4,0-4-2.8-8-2.8c-4,0-4,2.8-8,2.8c-4,0-4-2.8-8.1-2.8s-4,2.8-8.1,2.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHydrophobicFilter);
export default __webpack_public_path__ + "static/media/hydrophobicFilter.fbacf71d4c4fcc12973e209947ae9ab4.svg";
export { ForwardRef as ReactComponent };